import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { useState } from 'react';
/**
 * Open the enrichment properties panel and listen for close events.
 *
 * @param objectId {string}
 * @param objectTypeId {string}
 * @param onClose {function}
 * @returns {object} {isOpen, openEnrichmentPropertiesPanel}
 */
export function useEnrichmentPropertiesPanel({
  objectId,
  objectTypeId,
  onClose
}) {
  const [isOpen, setIsOpen] = useState(false);
  const sendEnrichPanelMessage = useSendCrmMessageTopic('OPEN_ENRICHMENT_PROPERTIES_PANEL');
  useOnCrmMessageTopic('CLOSE_ENRICHMENT_PROPERTIES_PANEL', data => {
    setIsOpen(false);
    onClose === null || onClose === void 0 || onClose(data.enriched);
  });
  function handleOpen() {
    sendEnrichPanelMessage({
      objectId,
      objectTypeId
    });
    setIsOpen(true);
  }
  return {
    isOpen,
    openEnrichmentPropertiesPanel: handleOpen
  };
}